module.exports = __webpack_public_path__ + "static/img/water-yam-intro.2a382b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/score/water-yam-intro.jpg
// module id = 5gcT
// module chunks = 0